<template>
    <div>
        <div class="flex flex-wrap lg:flex-nowrap -mx-2">
            <div
                v-for="(item, index) in items"
                :key="index"
                class="px-2 mb-4 flex-grow w-1/2 lg:full"
            >
                <CatalogueTile
                    :image="item.image.sizes.large"
                    :medium-image="item.medium_image.sizes.large"
                    :small-image="item.small_image.sizes.large"
                    :title="item.title"
                    :is-new="item.is_new"
                    :link="item.url"
                    :external-link="item.url.charAt(0) !== '/'"
                    :content="item.content"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CatalogueTile from '@/components/CatalogueTile';

export default {

    components: {
        CatalogueTile,
    },

    props: {
        items: {
            type: Array,
            required: true,
        },
    },

};
</script>

<style lang="scss" scoped>
.transform-scale {
    transform: scale(0.95);
}
</style>
